import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    QueryList,
    TemplateRef,
    ViewChildren
} from "@angular/core";
import {NodeModel} from "./model/NodeModel";
import {ChosenCategoryService} from "../../../../../../../../common/components/business-category/chosen-category.service";
import {isNullOrUndefined} from "util";
import {Subscription} from "rxjs";
import {CheckboxComponent} from "../../../../../../../../common/components/category-checkbox";
import { ViewRef_ } from "@angular/core/src/view";

@Component({
    selector: 'tfl-tree-view-node',
    template: `
        <div class="tfl-tree-view-node">
            <mat-expansion-panel hideToggle="hideToggle"
                                 (closed)="stateChanged()"
                                 (opened)="stateChanged()">
                <mat-expansion-panel-header [collapsedHeight]="collapsedHeight"
                                            [expandedHeight]="expandedHeight">
                    <ng-container
                            *ngIf="!opened"
                            [ngTemplateOutlet]="closedPanelIconTmpl"
                    ></ng-container>
                    <ng-container
                            *ngIf="opened"
                            [ngTemplateOutlet]="openedPanelIconTmpl"
                    ></ng-container>
                    <mat-panel-title>
                        {{ item.code + ' ' + item.name }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-panel-description>
                    <ul *ngIf="item.children.length > 0">
                        <li *ngFor="let child of item.children">
                            <ng-container *ngIf="child.children.length > 0 else list">
                                <tfl-tree-view-node
                                        [collapsedHeight]="_collapsedHeightPx"
                                        [expandedHeight]="_expandedHeightPx"
                                        [openedPanelIconTmpl]="openedPanelIconTmpl"
                                        [closedPanelIconTmpl]="closedPanelIconTmpl"
                                        [item]="child">
                                </tfl-tree-view-node>
                            </ng-container>
                            <ng-template #list>
                                <tfl-checkbox
                                        (itemSelected)="itemSelected($event)"
                                        (itemDeSelected)="itemDeSelected($event)"
                                        [item]="child"
                                        [label]="child.code + ' ' + child.name"
                                ></tfl-checkbox>
                            </ng-template>
                        </li>
                    </ul>
                </mat-panel-description>
            </mat-expansion-panel>
        </div>
    `
})
export class TreeViewNodeComponent implements AfterViewInit, OnDestroy {

    private readonly PX_ENDING = 'px';
    opened: boolean;
    @Input('item') item: NodeModel;
    @Input('hideToggle') hideToggle: boolean = false;
    @Input() openedPanelIconTmpl: TemplateRef<any>;
    @Input() closedPanelIconTmpl: TemplateRef<any>;
    @Input('collapsedHeight') _collapsedHeightPx: number = 48;
    @Input('expandedHeight') _expandedHeightPx: number = 48;
    @ViewChildren(CheckboxComponent) checkboxComponentQueryList: QueryList<CheckboxComponent>;

    private subscription: Subscription = Subscription.EMPTY;

    constructor(private categoryAnnounceService: ChosenCategoryService,
                private cdr: ChangeDetectorRef) {
    }

    get collapsedHeight(): string {
        return this._collapsedHeightPx.toString() + this.PX_ENDING;
    }

    get expandedHeight(): string {
        return this._expandedHeightPx.toString() + this.PX_ENDING;
    }


    stateChanged() {
        this.opened = !this.opened;
    }

    itemSelected(event: NodeModel) {
        this.categoryAnnounceService.selected(event);
    }

    itemDeSelected(event: NodeModel) {
        this.categoryAnnounceService.unSelected(event);
    }

    ngAfterViewInit(): void {
        this.categoryAnnounceService.categoriesLoadedEvent.subscribe(categories => {
            if (categories) {
                categories.forEach(category => {
                    this.checkboxComponentQueryList.filter(checkBox => !isNullOrUndefined(checkBox))
                        .map(checkBox => {
                            if (checkBox.item.id == category.id) {
                                checkBox.checked = true;
                            }
                        });
                });
            }
        });
        this.categoryAnnounceService.categoryDeletedEvent.subscribe(category => {
            this.markCategory(category, false);
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private markCategory(category, checked) {
        this.checkboxComponentQueryList.filter(checkBox => !isNullOrUndefined(checkBox))
            .map(checkBox => {
                if (checkBox.item.id == category.id && !(this.cdr as ViewRef_).destroyed) {
                    checkBox.checked = checked;
                    this.cdr.detectChanges();
                }
            });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/tree/tree-view-node.component.ts